module.exports = __webpack_public_path__ + "static/media/stepper-customize.2f9b5121.svg";